<template>
  <v-flex v-if="check === true" mr-2>
    <v-checkbox
      ref="search"
      :label="placeholder"
      v-model.trim="localValue"
      hide-details
      :readonly="readonly"
      @change="inputEvent"
    >
    </v-checkbox>
  </v-flex>
  <v-flex v-else mr-2>
    <v-flex v-if="type === 'date'">
      <date-picker
        ref="search"
        :label="placeholder"
        v-model.trim="localValue"
        :date-formatter="dateFormatter"
        :close-on-content-click="false"
        :readonly="readonly"
        append-icon="search"
        @input="inputEvent"
      />
    </v-flex>
    <v-flex v-else>
      <v-flex v-if="type === 'select'">
        <v-select
          v-model.trim="localValue"
          :items="items"
          append-icon="search"
          :label="placeholder"
          :item-text="itemText"
          :item-value="itemValue"
          hide-details="auto"
          filled
          clearable
          @change="inputEvent($event)"
        >
        </v-select>
      </v-flex>
      <v-flex v-else>
        <v-text-field
          ref="search"
          :label="placeholder"
          v-model.trim="localValue"
          hide-details
          append-icon="search"
          :clearable="clearable"
          @click:clear="$emit('input', null)"
          @input="inputEvent"
          :type="typeChamp"
        />
      </v-flex>
    </v-flex>
  </v-flex>
</template>

<script>
import { parseDate, formatFromIsoToFrDate } from '@/utils/date'

export default {
  props: {
    datasource: {
      type: Object,
      required: true,
    },
    attr: {
      type: String,
      default: 'name',
    },
    check: {
      type: Boolean,
    },
    i18n: {
      type: String,
    },
    type: {
      type: String,
      default: 'text',
    },
    typeChamp: {
      type: String,
      default: 'text',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    dateValue: null,
    callRefresh: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    initialValue: null,
    itemText: {
      type: String,
      default: 'libelle',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      localValue: this.datasource.args[this.attr],
      localCallRefresh: this.callRefresh,
      //valueField: this.$refs.search.value,
    }
  },
  watch: {
    localValue(val) {
      const valuetoemit = this.type === 'date' ? parseDate(val) : val

      this.$emit('emitsearchby', this.attr, valuetoemit)
      /*this.datasource.args[this.attr] =
        this.type === 'date' ? parseDate(val) : val;*/
    },
    datasource: {
      handler() {
        this.localValue = this.datasource.args[this.attr]
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(function () {
      if (this.dateValue) {
        this.$refs.search.localValue = this.dateValue
        //this.datasource.args[this.attr] = this.dateValue;
        this.$emit(this.datasource.args[this.attr], this.dateValue)
      }
    })
  },
  computed: {
    placeholder() {
      if (this.i18n) {
        return this.$t(this.i18n)
      }
      if (
        this.$te(
          this.datasource.labelNamespace + '.list.search.' + this.attr,
          this.$i18n.fallbackLocale,
        )
      ) {
        return this.$t(
          this.datasource.labelNamespace + '.list.search.' + this.attr,
        )
      } else {
        return this.$t(this.datasource.labelNamespace + '.search.' + this.attr)
      }
    },
  },
  methods: {
    focus() {
      this.$refs.search.focus()
    },
    inputEvent() {
      if (this.localCallRefresh == true) {
        this.datasource.debouncedRefresh()
      }
      this.$emit('storeSearch', this.datasource.args[this.attr])
    },
    dateFormatter(date) {
      return formatFromIsoToFrDate(date)
    },
  },
}
</script>
